import { FETCH_V2_DATA_START, FETCH_V2_DATA_SUCCESS, FETCH_V2_DATA_ERROR } from '../actions/actiontypes';

export default function (state = {}, action) {
  switch (action.type) {
    case FETCH_V2_DATA_START: {
      return {};
    }
    case FETCH_V2_DATA_ERROR: {
      return { error: action.payload }
    }
    case FETCH_V2_DATA_SUCCESS: {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
}